import { IZoneData, Zones as ZonesLib } from "@package/map";
import Api from "Api";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import { setTooltip } from "Redux/tooltipSlice";
import { changeApplySelected, changeAutoApply } from "Redux/zonesSlice";
import { changeLoadingMode } from "Redux/surveysSlice";
import { useEffect, useMemo, useState } from "react";
import { Marker, Pane, Rectangle, Tooltip } from "react-leaflet";
import _ from "lodash";
import { useQuery } from "@tanstack/react-query";
import useTrafficCount from "Hooks/useTrafficCount";

export default function TrafficHeatMap2() {
  const dispatch = useAppDispatch();

  const {
    source,
    destination,
    level,
    visible: zonesVisible,
    zone,
    zonesCount,
    showTopNumbers,
    heatMap2Mode,
    selectingType,
    autoApply,
    applySelecteds,
    forceUpdate,
    colorStep,
    showHeatMap2Numbers,
  } = useAppSelector((state) => state.trafficZones);
  const { visible: trafficVisible, trafficShowType } = useAppSelector((state) => state.traffic);
  const { zoom } = useAppSelector((state) => state.map);
  const { survayLayer } = useAppSelector((state) => state.layers);
  const StorageZonesData = useMemo(() => localStorage.getItem(`zone-data-${zone}-${level}`), [zone, level]);
  const [zonesData, setZonesData] = useState(StorageZonesData ? JSON.parse(StorageZonesData) : []);
  const [selectedZonesCount, setSelectedZonesCount] = useState<any>({ des: {}, src: {} });
  const [surveyCounts, setSurveyCounts] = useState<any>({ des: {}, src: {}, storedDes: {}, storedSrc: {} });
  const [allSurveyCounts, setAllSurveyCounts] = useState<any>({ des: {}, src: {} });

  const { data } = useTrafficCount();

  if (!trafficVisible || !data) return <></>;
  return (
    <>
      <Pane name="show_traffic_heatmap2" style={{ zIndex: survayLayer }} key={survayLayer}>
        <ZonesLib
          zone={zone}
          level={level}
          zoom={zoom}
          zonesVisible={zonesVisible}
          heatMap={true}
          haetmapZIndex={survayLayer}
          heatMapMode={heatMap2Mode}
          autoApply={autoApply}
          applySelecteds={applySelecteds}
          zonesCount={showTopNumbers ? zonesCount : 329}
          showTopNumbers={showTopNumbers}
          forceUpdate={forceUpdate}
          colorStep={colorStep}
          surveyCounts={surveyCounts}
          allSurveyCounts={{ des: {}, src: JSON.parse(`{${data?.TTO_Count}}`) }}
          isLoading={false}
          selectedZonesCount={selectedZonesCount}
          showHeatMap2Numbers={showHeatMap2Numbers}
          selectionMode={applySelecteds && trafficVisible && trafficShowType === 2}
          zonesColor={[
            { zones: source, color: "#00a185" },
            { zones: destination, color: "#07243e" },
          ]}
        />
      </Pane>
    </>
  );
}
